import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["page-wizard-stepper", _ctx.disabledClasses]
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}